import * as Routes from './constants/routes'

export default {

  items: [
    {
      name: 'Device List',
      url: Routes.DEVICE_LIST,
      icon: 'icon-layers'
    },
    {
      name: 'Leak List',
      url: Routes.LEAK_LIST,
      icon: 'icon-drop'
    },
    {
      name: 'Event List',
      url: Routes.EVENT_LIST,
      icon: 'icon-calendar'
    },
    {
      name: 'Incomplete Installs',
      url: Routes.INCOMPLETE_INSTALLS,
      icon: 'icon-exclamation'
    },
    {
      name: 'Removed Devices',
      url: Routes.REMOVED_DEVICES,
      icon: 'icon-ban'
    },
    {
      name: 'Tenant List',
      url: Routes.TENANTS_LIST,
      icon: 'icon-list'
    },
    {
      name: 'Tenant Groups',
      url: Routes.TENANT_GROUPS,
      icon: 'icon-organization'
    },
    {
      name: 'Assign Tenant',
      url: Routes.ASSIGN_TENANT,
      icon: 'icon-refresh'
    },
    {
      name: 'Reports',
      url: Routes.REPORTS,
      icon: 'icon-doc'
    },
    {
      name: 'Message List',
      url: Routes.MESSAGE_LIST,
      icon: 'icon-envelope'
    },
    {
      name: 'Access Control',
      url: Routes.ROLES_API,
      icon: 'icon-people'
    },
    {
      name: 'Add Api to Role',
      url: Routes.ADD_API_2_ROLE,
      icon: 'icon-target'
    },
    {
      name: 'Add Role to Api',
      url: Routes.ADD_ROLE_2_API,
      icon: 'icon-target'
    },
    {
      name: 'User List',
      url: Routes.USER_LIST,
      icon: 'icon-people'
    },
    {
      name: 'Orders Mgmt',
      url: Routes.ORDERS_MANAGEMENT,
      icon: 'icon-basket'
    },
    {
      name: 'Search',
      url: Routes.SEARCH,
      icon: 'icon-magnifier'
    }
  ],
  itemsAdmin: [
    {
      name: 'Device List',
      url: Routes.DEVICE_LIST,
      icon: 'icon-layers'
    },
    {
      name: 'Leak List',
      url: Routes.LEAK_LIST,
      icon: 'icon-drop'
    },
    {
      name: 'Event List',
      url: Routes.EVENT_LIST,
      icon: 'icon-calendar'
    },
    {
      name: 'Incomplete Installs',
      url: Routes.INCOMPLETE_INSTALLS,
      icon: 'icon-exclamation'
    },
    {
      name: 'Removed Devices',
      url: Routes.REMOVED_DEVICES,
      icon: 'icon-ban'
    },
    {
      name: 'Reports',
      url: Routes.REPORTS,
      icon: 'icon-doc'
    },
    {
      name: 'Assign Tenant',
      url: Routes.ASSIGN_TENANT,
      icon: 'icon-refresh'
    },
    {
      name: 'Orders Mgmt',
      url: Routes.ORDERS_MANAGEMENT,
      icon: 'icon-basket'
    },
    {
      name: 'Search',
      url: Routes.SEARCH,
      icon: 'icon-magnifier'
    }
  ],
  itemsAnalytics: [
  ],
  itemsMaintenanceManager: [
    {
      name: 'Leak List',
      url: Routes.LEAK_LIST,
      icon: 'icon-drop'
    },
    {
      name: 'Reports',
      url: Routes.REPORTS,
      icon: 'icon-doc'
    },
    {
      name: 'Search',
      url: Routes.SEARCH,
      icon: 'icon-magnifier'
    }
  ],
  itemsInsuranceManager: [
    {
      name: 'Dashboard',
      url: Routes.PARTNER_DASHBOARD_IM,
      icon: 'icon-pie-chart'
    },
    {
      name: 'Leak List',
      url: Routes.LEAK_LIST,
      icon: 'icon-drop'
    },
    {
      name: 'Claims Mitigation Reports',
      url: Routes.LEAK_INVESTIGATION_REPORTS,
      icon: 'icon-wrench'
    },
    {
      name: 'Reports',
      url: Routes.REPORTS,
      icon: 'icon-doc'
    },
    {
      name: 'Search',
      url: Routes.SEARCH,
      icon: 'icon-magnifier'
    }
  ],
  itemsExternalOperations: [
    {
      name: 'Leak List',
      url: Routes.LEAK_LIST,
      icon: 'icon-drop'
    },
    {
      name: 'Event List',
      url: Routes.EVENT_LIST,
      icon: 'icon-calendar'
    },
    {
      name: 'Assign Tenant',
      url: Routes.ASSIGN_TENANT,
      icon: 'icon-refresh'
    },
    {
      name: 'Reports',
      url: Routes.REPORTS,
      icon: 'icon-doc'
    },
    {
      name: 'Search',
      url: Routes.SEARCH,
      icon: 'icon-magnifier'
    }
  ],
  itemsDeviceConfigurationManager: [
    {
      name: 'Update Parameters',
      url: Routes.UPDATE_PARAMETERS,
      icon: 'icon-refresh'
    },
    {
      name: 'Matlab Parameters Dictionary',
      url: Routes.MATLAB_PARAMETERS_DICTIONARY,
      icon: 'icon-wrench'
    },
    {
      name: 'Device Matlab Parameters',
      url: Routes.DEVICE_MATLAB_PARAMETERS,
      icon: 'icon-drop'
    }
  ]
}
